* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

gz-link {
  padding-top: calc(var(--spacer) * 10);
}

gz-basic-table::part(column-1),
gz-basic-table::part(column-2) {
  justify-content: center;
}

// We need to fix the content sizes of those columns to make justify-content: center; to also have the contents
// left-aligned. Otherwise, contents with variable lengths will be misaligned on the left and right borders.
gz-basic-table::part(column-content-1) {
  display: block;
  min-width: 64px;
}

gz-basic-table::part(column-content-2) {
  display: block;
  min-width: 128px;
}
